import React from "react";
import { FaCheckCircle } from "react-icons/fa";
import { FaStar, FaLaptop } from "react-icons/fa";

export default function HowItWorks() {
  return (
    <div className="howItWorks-section lightBg">
      <div className="container">
        <div className="row textCenter headerInfo">
          <div className="col-12">
            <h2 className="font40 extraBold textCenter">How It Works</h2>
          </div>
        </div>

        <div className="row steps-wrapper">
          {/* Step 1 */}
          <div className="col-md-4 col-sm-12 step-column">
            <div className="step-box">
              <div className="step-circle">1</div>
              <FaCheckCircle className="step-icon" />
              <h4 className="font18 semiBold">Safe & Reliable</h4>
              <p className="font12">
                Your safety is our first priority. We do a thorough background check on all staff members.
              </p>
            </div>
          </div>

          {/* Step 2 */}
          <div className="col-md-4 col-sm-12 step-column">
            <div className="step-box">
              <div className="step-circle">2</div>
              <FaStar className="step-icon" />
              <h4 className="font18 semiBold">3-Month Replacement</h4>
              <p className="font12">
                If the employee leaves or doesn’t meet expectations, we provide a free replacement within 3 months.
              </p>
            </div>
          </div>

          {/* Step 3 */}
          <div className="col-md-4 col-sm-12 step-column">
            <div className="step-box">
              <div className="step-circle">3</div>
              <FaLaptop className="step-icon" />
              <h4 className="font18 semiBold">Seamless Support</h4>
              <p className="font12">
                Get real-time updates and chat with our team anytime for queries, bookings, or feedback.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Embedded Styles */}
      <style>{`
        .howItWorks-section {
          padding: 60px 0;
        }

        .step-subtitle {
          color: #3498db;
          letter-spacing: 1px;
          margin-bottom: 10px;
        }

        .steps-wrapper {
          margin-top: 40px;
          @media (max-width: 860px) {
            justify-content: center;
            }
        }

        .step-column {
          display: flex;
          justify-content: center;
          margin-bottom: 30px;
        }

        
        .headerInfo{
        justify-content: center;
          @media (max-width: 860px) {
            text-align: center !important;
            justify-content: center;
            }
        }

        .step-box {
          background: #fff;
          padding: 30px;
          border-radius: 16px;
          text-align: center;
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
          position: relative;
          width: 100%;
          max-width: 300px;
        }

        .step-circle {
          position: absolute;
          top: -20px;
          right: -20px;
          background: #3b4865;
          color: white;
          font-size: 16px;
          width: 40px;
          height: 40px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          z-index: 1;
        }

        .step-icon {
          font-size: 40px;
          color: #d32f2f;
          margin-bottom: 20px;
        }

        .font12 {
          font-size: 12px;
        }

        .font15 {
          font-size: 15px;
        }

        .font18 {
          font-size: 18px;
        }

        .font40 {
          font-size: 40px;
        }

        .semiBold {
          font-weight: 600;
        }

        .extraBold {
          font-weight: 800;
        }

        @media (max-width: 768px) {
          .font40 {
            font-size: 28px;
          }

          .step-box {
            padding: 20px;
          }
        }
      `}</style>
    </div>
  );
}
